import styled from 'styled-components';

import {
  Dropdown as DropdownComponent,
  FormField as FormFieldComponent,
} from '@xing-com/text-field';
import { spaceL } from '@xing-com/tokens';

export const FormField = styled(FormFieldComponent)`
  margin-top: ${spaceL};
`;

export const Dropdown = styled(DropdownComponent)`
  margin-top: ${spaceL};
`;
